export default "__VITE_ASSET__626a3848__"